module.exports = __webpack_public_path__ + "img/9_106.13bba651.png";